import React from "react";

// @deprecated

const ActiveContext = React.createContext({});

export default ActiveContext;